import { COLORS } from '@btime/constants'
import { useNotification } from '@btime/react-messager'
import React, { useRef, Fragment } from 'react'

import { Hide } from '../helpers/Visibility'
import { Label, Text } from './Text'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Input from '../form/Input'
import Link from '../actions/Link'

const handleCopyLink = (ref, onSuccess) => () => {
  const input = ref.current
  if (!input) return false
  input.select()
  input.setSelectionRange(0, 99999) /*For mobile devices*/
  document.execCommand('copy')
  onSuccess()
}

const ShareLink = ({ label, url, textOnly }) => {
  const inputRef = useRef()
  const notify = useNotification()
  const copyLink = handleCopyLink(inputRef, () => notify.success({ title: 'Link copiado!' }))

  return (
    <Fragment>
      {label && <Label>{label}</Label>}
      <FlexGrid gutter={0.3} justify="flex-start">
        <FlexCol flex={textOnly ? 0 : 1}>
          <Hide condition={textOnly} useOpacity noSpace>
            <Input readOnly value={url} inputRef={inputRef} noTransform />
          </Hide>

          {textOnly && (
            <Text size="small" bold noWrap>
              {url}
            </Text>
          )}
        </FlexCol>
        <Link onClick={copyLink}>
          {textOnly ? (
            <Icon name="BsSubtract" size="1rem" />
          ) : (
            <Text bold color={COLORS.purple} size="xsmall" noWrap>
              Copiar link
            </Text>
          )}
        </Link>
      </FlexGrid>
    </Fragment>
  )
}

export default ShareLink
